var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 1031.4v10c0 4.2 3.6322 8 9 10 5.368-2 9-5.8 9-10v-10h-18z",
    fill: "#95a5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 1030.4v10c0 4.2 3.6322 8 9 10 5.368-2 9-5.8 9-10v-10h-18z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 1030.4v10c0 4.2 3.6322 8 9 10v-20h-9z",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 1032.4v8c0 3.4 2.8251 6.4 7 8 4.175-1.6 7-4.6 7-8v-8h-14z",
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 1032.4v16c4.175-1.6 7-4.6 7-8v-8h-7z",
    fill: "#2ecc71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 1037.4-4.683 4.6-1.9511-1.9-1.6586 1.7 1.9512 1.9 1.5615 1.6 0.097 0.1 6.342-6.4-1.659-1.6z",
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 1036.4-4.683 4.6-1.9511-1.9-1.6586 1.7 1.9512 1.9 1.5615 1.6 0.097 0.1 6.342-6.4-1.659-1.6z",
    fill: "#ecf0f1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.35af103685c8204ca66cd19cc4ed72f9.svg";
export { ForwardRef as ReactComponent };